import { Action, createReducer, on } from '@ngrx/store';
import * as MessageHubActions from '../../../../state/actions/message-hub.actions';
import { CentralStaffStatusViewGridData } from '../../shared/models/central-staff-status-view.model';
import * as LobbyCentralViewAPIActions from '../actions/lobby-central-views.actions';

export interface LobbyCentralStaffViewState {
    locationId: number[] | null;
    assistType: number | null;
    isLocationChanged: boolean;
    searchText: string;
    isInitialLoading: boolean;
    data: CentralStaffStatusViewGridData;
}

const initialLobbyCentralStaffViewState: LobbyCentralStaffViewState = {
    locationId: null,
    assistType: null,
    isLocationChanged: false,
    searchText: '',
    data: { totalRowCount: 0, pageSize: 0, currentPageNumber: 0, data: [], numberOfPages: 0 },
    isInitialLoading: true

};

const reducer = createReducer<LobbyCentralStaffViewState>(
    initialLobbyCentralStaffViewState,
    on(MessageHubActions.receivedCentralStaffStatusGridData, (LobbyCentralStaffGridState, action): LobbyCentralStaffViewState => (
        {
            ...LobbyCentralStaffGridState,
            data: JSON.parse(action.messageData)
        }
    )),
    on(LobbyCentralViewAPIActions.setAssistType, (LobbyCentralStaffGridState, action): LobbyCentralStaffViewState => (
        {
            ...LobbyCentralStaffGridState,
            assistType: action.assistType
        }
    )),
    on(LobbyCentralViewAPIActions.searchTextChange, (LobbyCentralStaffGridState, action): LobbyCentralStaffViewState => (
        {
            ...LobbyCentralStaffGridState,
            searchText: action.searchText
        }
    ))
);

export function lobbyCentralStaffViewReducer(state: LobbyCentralStaffViewState | undefined, action: Action) {
    return reducer(state, action);
}
